import type { ProjectStatus } from '../types';

export const MOCK_STATUSES: ProjectStatus[] = [
  {
    id: 's1',
    name: 'To do',
    type: 'todo',
    color: 'cyan-glacier',
    order: 0,
    boardId: 'mock-board',
  },
  {
    id: 's2',
    name: 'In progress',
    type: 'in-progress',
    color: 'indigo-vortex',
    order: 1,
    boardId: 'mock-board',
  },
  {
    id: 's3',
    name: 'QA',
    type: 'in-progress',
    color: 'pink-flamingo',
    order: 2,
    boardId: 'mock-board',
  },
  {
    id: 's4',
    name: 'Done',
    type: 'done',
    color: 'green-emerald',
    order: 3,
    boardId: 'mock-board',
  },
];
